module.exports = __webpack_public_path__ + "img/icon_volunteer_selected.a841a3e3.svg";